import { gql } from "@apollo/client";
import { AccountRoleType } from "../fragments";

/**
 * Domain type for a single available account context entry returned by the API.
 * Includes the root/parent account when it is accessible to the current user.
 */
export interface AvailableAccountContext {
  id: string;
  displayName: string;
  roleType: AccountRoleType;
}

/** Root response type for the AvailableAccountContexts query. */
export interface GetAvailableAccountContextsData {
  availableAccountContexts: AvailableAccountContext[];
}

/**
 * Fetches all account contexts visible to the current user, ordered alphabetically
 * by display name. The result set may include the root/parent account itself in
 * addition to child accounts.
 *
 * Used by AccountContextProvider on mount to populate the switcher and validate
 * any stored context ID.
 */
export const GET_AVAILABLE_ACCOUNT_CONTEXTS = gql`
  query AvailableAccountContexts {
    availableAccountContexts: available_account_context(order_by: { display_name: asc }) {
      id
      displayName: display_name
      roleType: role_type
    }
  }
`;
